import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MunicipioModel } from '@shared/models/backend'
import { SelectFieldProvider } from 'src/app/widgets/select-field/select-field-provider'

@Component({
  selector: 'app-municipio',
  templateUrl: './municipio.component.html',
})
export class MunicipioComponent {
  @Input() municipioForm: FormControl
  @Input() municipioProvider: SelectFieldProvider<MunicipioModel>
  @Output() municipioInvalidEvent: EventEmitter<any> = new EventEmitter()
  // Indica em qual form o componente está inserido
  @Input()
  idForm: string

  onMunicipioInvalid(): void {
    this.municipioInvalidEvent.emit()
  }
}
